module.exports = __webpack_public_path__ + "img/info_bigger.67f14238.svg";